import React, { Fragment } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

const HeaderActions = ({pageBack, titlePage, ButtonAction}) => {
  const ButtonDisplay = ButtonAction ? ButtonAction : Fragment
  return (
    <Container fluid className="text-center py-3 custom-padding container-sticky">
      <Row className="justify-content-between">
        <Col xs={1} className="text-left">
          <p className="text-5 text-color-primary font-weight-bolder my-0 pt-1 pl-5">
            {(typeof pageBack === 'function') ? 
              <button
                className="btn-arrow"
                id="load-details-back-button"
                onClick={() => pageBack()}
              > 
                <i className="icon-arrow-left" />
              </button> 
            : null}
          </p>
        </Col>
        <Col className="d-flex align-items-center justify-content-start pl-5">
          <span className="text-4 font-weight-bold ">{titlePage}</span>
        </Col>
        <Col className="align-items-center text-right pr-5">
          <ButtonDisplay />
        </Col>
      </Row>
    </Container>
  )
}

export default HeaderActions;